<p>
  @for (part of line || []; track $index) {
    <span
      class="rounded-sm px-1.5 my-0.5"
      [ngClass]="{
        'bg-diff-added': part.partType == partType.Added,
        'bg-diff-removed': part.partType == partType.Removed,
        'text-black': part.partType == partType.Added || part.partType == partType.Removed,

        'text-amazone-gray': part.partType == partType.Same,
      }"
      >{{ part.text }}</span
    >
  }
</p>
